export default __webpack_public_path__ + "static/media/omnes_light-webfont.bbf8a710.eot";